import { Favorite, FavoriteClient } from 'api/clients/FavoriteClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery } from 'react-query'
import { useDispatch } from 'react-redux'
import { favoritesSet } from 'redux/actions'

const useFavorites = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const dispatch = useDispatch()

  const favorites = useQuery<Favorite[] | undefined, Error>(
    ['workspace', currentWorkspaceId, 'files', 'favorites'],
    async () => {
      const res = await FavoriteClient.getFavorites()
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(res.type === 'error' ? res.status.toString() : undefined)
      }

      const favorites = res.data.favorites.filter(
        (favorite) => favorite.favoritable_workspace_id === currentWorkspaceId,
      )
      dispatch(favoritesSet(favorites))

      return favorites
    },
    {
      staleTime: Infinity, // We're going to invalidate this manually
    },
  )

  return favorites
}

export { useFavorites }
